/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_RedirectingInputs */

const zh_auth_redirecting = /** @type {(inputs: Auth_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`跳转中...`)
};

const en_auth_redirecting = /** @type {(inputs: Auth_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirecting...`)
};

const es_auth_redirecting = /** @type {(inputs: Auth_RedirectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirigiendo...`)
};

/**
* | output |
* | --- |
* | "Redirecting..." |
*
* @param {Auth_RedirectingInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_redirecting = /** @type {((inputs?: Auth_RedirectingInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_RedirectingInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_redirecting(inputs)
	if (locale === "en") return en_auth_redirecting(inputs)
	return es_auth_redirecting(inputs)
});